import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataTableSkeleton,
  FilterType,
  UserPermission
} from '@globaleris/ui.library'
import { Card, CardContent, CardHeader, Grid, makeStyles, Paper, useTheme } from '@material-ui/core'
import CloudDownloadRoundedIcon from '@material-ui/icons/CloudDownloadRounded'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnumGrupoDocumento } from '../../../../api'
import { generateIconsFromConfiguration } from '../../../../helpers/dataTableActionIconHelper'
import { fileDownloadHelper } from '../../../../helpers/fileDownloadHelper'
import { ActionIcons } from '../../../../model'
import { regulatoryReportDownloadCard } from '../../regulatoryReports.Model'
import {
  downloadCoresReportFile,
  filterApplicableActionsConfigurationRemit
} from '../../regulatoryReports.service'
import { styles } from '../../regulatoryReports.styles'

export interface ReportTableProps {
  tableName: string
  isFetching: boolean
  groupDocumentToFilter: EnumGrupoDocumento[]
  columns: DataTableColumn[]
  data: any
}

export const ReportTable: React.FC<ReportTableProps> = ({
  tableName,
  isFetching,
  groupDocumentToFilter,
  columns,
  data
}) => {
  const [t] = useTranslation(['regulatoryReports', 'enums', 'storageHelper'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  // React.useEffect(() => {
  //   const fetchData = () => {
  //     fetchRegulatoryReportFilesPower()
  //   }

  //   fetchData()

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [refreshChild])

  const completeDataTableActions = (
    item: regulatoryReportDownloadCard
  ): regulatoryReportDownloadCard => {
    return {
      ...item,
      actions:
        item.actionsConfiguration &&
        item.actionsConfiguration.length > 0 &&
        generateIconsFromConfiguration(
          item,
          filterApplicableActionsConfigurationRemit(item, item.actionsConfiguration),
          new Map<ActionIcons, Function>([])
        )
    }
  }

  //#region Handlers

  const onDownloadHandler = async (row: regulatoryReportDownloadCard) => {
    const response = await downloadCoresReportFile(row)
    if (response.success && response.data) {
      fileDownloadHelper(response.data.name, response.data)
    }
  }

  //#endregion

  //#region DataTable definition

  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 0,
    filterType: FilterType.ADVANCED,
    download: false,
    print: false,
    selectableRows: false,
    canDelete: false,
    canEdit: false,
    rowCustomActions: [
      {
        userPermission: UserPermission.READ_ONLY,
        icon: <CloudDownloadRoundedIcon fontSize="small" />,
        tooltip: t('regulatoryReports:regulatoryReportsDownloadCard.actions.download'),
        onClick: onDownloadHandler,
        visibleIf: 'canDownload'
      }
    ],
    selectToolbarCustomActions: []
  }

  //#endregion

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid item lg={12}>
          <Paper elevation={6}>
            <Card>
              <CardHeader
                title={t(`regulatoryReports:components.reportTable.title.${tableName}`)}
              ></CardHeader>
              <CardContent>
                {isFetching ? (
                  <DataTableSkeleton rows={2} />
                ) : (
                  <DataTable data={data} columns={columns} options={options} />
                )}
              </CardContent>
            </Card>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}
